import { getLanding } from "../service/club/api";
import { parseAgreementToTheme } from "../service/club/utils";

const SLUG_MAPPINGS: Record<string, string> = {
  'viuvantagens': 'viu',
  //'localhost': 'clubeviptelecom',
  'localhost': 'clubeligga2',
  'b28': 'grajavantagens',
  'pandavantagens': 'pandavantagens',
  'club.cyberinternet.com.br': 'cyberclub',
  'clube.plis.com.br': 'plis',
  'vantagens.azat.com.br': 'azatvantagens',
  'vantagens.evolveinternet.com.br': 'evolvevantagens',
  'clubedevantagens.brasilnet.net.br': 'brasilnetclubedevantagens',
  'workmaisvantagens.com.br': 'workmaisvantagens',
  'vantagens.internettelecom.com.br': 'telecomvantagens',
  'netmittlivros.ebooks.app.br': 'netmittlivros',
  'clubeliggavc': 'clubeligga',
  'clubeligga.com.br': 'clubeligga',
  'www.clubeligga.com.br': 'clubeligga',
  'clubedevantagens.grupolima.net.br': 'clubedevantagensgrupolima'
};

function extractSlugFromHostname(): string {
  const hostname = window.location.hostname;

  if (hostname.includes('partiu.com.br')) {
    return hostname.split('.')[0];
  }

  return hostname;
}

function localClubOverride(): string | null {
  if (window.location.hostname !== 'localhost') return null;
  const club = new URLSearchParams(window.location.search).get('club')?.trim();
  return club || null;
}

function mapSlugToTheme(slug: string): string {
  const normalized = slug.toLowerCase().trim();
  // Prioriza correspondência exata
  if (SLUG_MAPPINGS[normalized]) {
    return SLUG_MAPPINGS[normalized];
  }
  for (const [key, value] of Object.entries(SLUG_MAPPINGS)) {
    if (normalized.includes(key)) {
      return value;
    }
  }
  return normalized;
}

export async function themeResolver() {
  try {
    const clubOverride = localClubOverride();
    const extractedSlug = clubOverride || extractSlugFromHostname();
    let themeSlug = clubOverride || mapSlugToTheme(extractedSlug);


    if(themeSlug === 'www.clubeligga.com.br') {
      themeSlug = 'clubeligga';
    }
    const response = await getLanding(themeSlug);
    return parseAgreementToTheme(response);
  } catch (error) {
    return null;
  }
}
